import { useContext } from 'react';
import { OrderTableContext, IOrderTableContext } from './OrderTableContext';

export const useOrderTable = () => useContext<IOrderTableContext>(OrderTableContext);
